module.exports = __webpack_public_path__ + "static/logo_pocket-6cb3fad00e9162511bd6574280e9d312.png";